import React from 'react';
import { FormattedMessage } from 'react-intl';

import Icon from 'components/ui/Icon';
import Button, { ButtonType } from 'components/ui/Button';

import { SignDocument } from './types';

const Document: React.FC<SignDocument & { onClick: (id: string) => () => void }> = ({
  id, read, filename, onClick,
}) => (
  <div className="p-3 mb-3 kiosk:p-6 rounded-lg items-center flex cursor-pointer bg-card-bg gap-3 kiosk:gap-6">
    <div className="flex">
      {read && (
        <Icon
          className="fb-icon--checkmark-circle-1 text-4xl kiosk:text-6xl text-success-default"
          data-testid="read-success"
        />
      )}
      {!read && (
        <Icon
          className="fb-icon--file text-4xl kiosk:text-6xl text-default"
          data-testid="read-not-done"
        />
      )}
    </div>
    <div className="grow w-full overflow-hidden">
      <p className="text-default font-medium line-clamp-2 text-ellipsis">
        {filename}
      </p>
    </div>
    <Button type={read ? ButtonType.PRIMARY : ButtonType.WHITE} testId={`document-${id}`} onClick={onClick(id)} className="!text-button-xs !py-0 h-btn whitespace-nowrap">
      <FormattedMessage id="consult" defaultMessage="Consult" />
    </Button>
  </div>
);

export default Document;
